export const LogoMark = ({ className = "w-9 h-9" }) => (
  <svg viewBox="0 0 48 48" fill="none" className={className} aria-hidden="true">
    <path
      d="M34.9 16A16 16 0 1 0 34.9 32"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
    />
    <rect x="25" y="17" width="3.2" height="19" rx="0.5" fill="#B99C6A" />
    <rect x="31.5" y="9" width="3.2" height="27" rx="0.5" fill="#B99C6A" />
  </svg>
);
